
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";

interface AccountHeaderProps {
  phoneNumber: string;
}

export default function AccountHeader({
  phoneNumber
}: AccountHeaderProps) {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  
  const handleLogout = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Error during logout:", error);
      toast.error("Couldn't complete logout. Please try again.");
      navigate("/verify");
    }
  };
  
  const formatPhoneForDisplay = (phone: string) => {
    return phone.replace("+61", "0").replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3");
  };
  
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6">
      <h1 className="text-2xl font-bold">
        Your Account for {formatPhoneForDisplay(phoneNumber)}
      </h1>
      
      <Button 
        variant="outline" 
        size="sm" 
        onClick={handleLogout}
        className="self-start sm:self-auto"
      >
        <LogOut className="h-4 w-4 mr-2" />
        <span>Log Out</span>
      </Button>
    </div>
  );
}
